<template>
  <div class="c-text-between px-container c-flex-wrap">
    <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
      <span class="c-mb-10">保持技术前沿</span>
      <h1 class="c-text-left">FRANKA RESEARCH 3 最新版本发布</h1>
      <span class="c-mt-5  c-text-left text-indent">
        凭借新增功能、扩展模块与性能优化持续领先
      </span>
      <span class="c-mb-5 c-text-left text-indent">
        FR3系统及软件通过免费无线升级（OTA）持续进化
      </span> 
    </div>

    <div class="display-width">
      <img src="@/assets/images/company/_Frank Robotics0363_RESIZED.jpg" alt=""
        style="    height: auto; max-width: 100%;">
    </div>
  </div>
  
  <div id="resources-productdocumentation"></div>
  <div class="line-with-text px-container">
    <hr class="divider">
    <span class="line-text">系统镜像</span>
    <hr class="divider">
  </div>  
  <div class="px-container"> 
     <h1 class="c-text-left" style="font-size: 28px;">系统镜像 v5.8</h1>
     <div class="c-text-left c-mb-40">本次更新致力于为开发者和操作员提供更强的控制力、可视化程度及易用性。基于实际工作流程优化，此版本带来全方位的实质性改进——从精细化校准到简化的调试流程，以及更精致的用户体验。</div>
     <h1 class="c-text-left c-mb-40" style="font-size: 28px;">更新内容</h1>
     <div class="c-text-left c-mb-5"> <strong class="c-font-18">Desk API（全新免费功能！）</strong></div><strong></strong>
     <div class="c-text-left c-mb-20">Desk API 是一个全新的REST接口，可通过编程方式管理您的机器人——包括解锁制动器、激活FCI（力控制接口）、清除可恢复的安全违规等操作。该功能现<strong>已预装</strong>在所有FR3系统中，您可直接通过<strong>Desk下拉菜单</strong>或访问链接<strong>＜您的机器人IP/＞deskapi</strong> 获取API及其文档。</div>
     <div class="c-text-left c-mb-40">随心所欲，全面操控</div>
     <div class="c-text-left c-mb-5"> <strong class="c-font-18">扭矩传感器自动校准</strong></div>
     <div class="c-text-left c-mb-40">您现在可直接通过<strong>Franka操作界面</strong>（robot.franka.de/settings）在设置中自动重新校准机器人扭矩传感器！只需按照分步指引操作，应用校准值后重启机械臂即可。</div>
     <div class="c-text-left c-mb-5"> <strong class="c-font-18">可下载日志文件</strong></div>
     <div class="c-text-left c-mb-5">故障诊断更轻松！</div>
     <div class="c-text-left c-mb-5">您现在可直接从<strong>设置</strong>选项卡下载用户专属日志文件（包含事件数据与循环数据）。</div>
     <li class="c-text-left c-mb-10">文件可无障碍访问且未加密</li>
     <li class="c-text-left c-mb-40">支持通过<strong>Desk界面</strong>及<strong>Desk API</strong>获取</li>
     <div class="c-text-left c-mb-5"> <strong class="c-font-18">Desk操作体验优化</strong></div>
     <li class="c-text-left c-mb-10"><strong>全新侧边栏 </strong>- 通过标签页分类导航及3D机器人视图提升操作效率</li>
     <li class="c-text-left c-mb-10"><strong>简化更新流程</strong> - 提供更流畅的软件更新体验</li>
     <li class="c-text-left c-mb-40"><strong>运动预备倒计时</strong>  - 机械臂动作启动前显示明确倒计时提示</li>
     <div class="c-text-left c-mb-5"> <strong class="c-font-18">修复与稳定性改进</strong></div>
     <div class="c-text-left c-mb-10">本版本包含以下关键修复与优化：</div>
     <li class="c-text-left c-mb-10"><strong>位姿存储</strong>  - 修复多位置点保存异常问题</li>
     <li class="c-text-left c-mb-10"><strong>夹爪宽度</strong>  - 解决重启后最大宽度显示错误</li>
     <li class="c-text-left c-mb-10"><strong>Desk执行</strong>  - 修复焦点跳转异常</li>
     <li class="c-text-left c-mb-10"><strong>自碰撞检测</strong>  - 现支持外部扭矩控制模式下正常工作</li>
     <li class="c-text-left c-mb-10"><strong>软件更新</strong>  - 优化错误处理机制</li>
     <li class="c-text-left c-mb-10"><strong>系统启动</strong>  & TD2自检 - 提升初始化可靠性</li>
     <li class="c-text-left c-mb-10"><strong>SPoC令牌</strong>  - 修复多次页面刷新后的令牌丢失问题</li>
     <li class="c-text-left c-mb-10"><strong>安全监控报告</strong>  - 修正数值舍入错误</li>
     <li class="c-text-left c-mb-10"><strong>时间轴菜单</strong>  - 现支持左/右键点击正常关闭</li>
     <li class="c-text-left c-mb-10"><strong>惯量处理</strong>  - 零质量模式下行为一致性优化，新增非零末端惯量忽略警告</li>
     <li class="c-text-left c-mb-10"><strong>学习服务</strong>  - 修复优化过程中的显示异常</li>
     <li class="c-text-left c-mb-10"><strong>回零流程</strong>  - 禁止Franka Hand手动初始化，确保安全模块异常(SMSS)后制动器释放自动回零</li>
     <li class="c-text-left c-mb-10"><strong>FCI激活</strong>  - 修复无效安全设置导致的错误及提前终止问题</li>
     <li class="c-text-left c-mb-10"><strong>嵌套任务</strong>  - 修正任务执行过程中的空间占用声明</li>
     <li class="c-text-left c-mb-10"><strong>模式切换</strong>  - 防止外部使能设备激活时从执行模式跳转至编程模式</li>
     <li class="c-text-left c-mb-10"><strong>急停按钮</strong>  - 修复Franka Hand回零期间的可用性异常</li>
     <li class="c-text-left c-mb-20"><strong>关节锁定指令</strong>  - 修复指令等待执行结束的判定逻辑</li>
     <div class="c-text-left c-mb-40">完整更新内容详见版本 
      <a class="linkTag" href="https://download.franka.de/Franka_Robotics_Update_History.pdf">发布说明</a>。  
     </div>
     <h1 class="c-text-left c-mb-20" style="font-size: 28px;">重要通知</h1>
     <div class="c-text-left c-mb-5"> <strong class="c-font-18">Motion API v1 弃用声明</strong></div>
     <div class="c-text-left c-mb-40">Motion API v1 已正式弃用，将在未来版本中全面由 Motion API v2 取代。请尽快迁移至 Motion API v2 以获得持续支持及新功能访问权限！</div>
     <h1 class="c-text-left c-mb-20" style="font-size: 28px;">参与讨论</h1> 
     <div class="c-text-left c-mb-5">欢迎通过<a class="linkTag" href="https://www.franka-community.de/"> Franka社区论坛</a>与我们交流！</div>
     <li class="c-text-left c-mb-10">请在【社区与项目】板块分享您对新版本的使用经验或项目案例</li>
     <li class="c-text-left c-mb-10">如需文档改进建议或资源需求，请在【文档与反馈】板块添加#docs标签提交</li>
     <li class="c-text-left" style="margin-bottom: 120px;">遇到任何问题或疑问，欢迎在对应板块发帖——我们将竭诚为您提供支持！</li>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  metaInfo() {
      return {
        title: this.$route.meta.title, // 从路由获取标题
        meta: [
          { 
            name: 'keywords', 
            content: this.$route.meta.metaTags[0]['content']
          }
        ]
      }
    },
  name: 'App',
  components: {
    // HelloWorld
  },
  data(){
    return {  
      
    }
  }, 
}
</script>

<style scoped>

.display-width{
  width: calc(50% - 40px);
}

@media (max-width: 1029px) {
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 899px) {
  .display-width{
    width: 100%
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
}

</style>
<style scoped> 
/* h2 {
  font-size: 14px;
  margin-top: 10px;
  color: #333;
} */
.wechat-image {
display: none;
position: absolute;
bottom: 25px;
left: 50%;
width: 120px;
height: auto;
transform: translateX(-50%);
}

.linkTag:hover .wechat-image {
display: block; /* 鼠标悬停时显示图片 */
}
li::marker {
    unicode-bidi: isolate;
    font-variant-numeric: tabular-nums;
    text-transform: none;
    text-indent: 0px !important;
    text-align: start !important;
    text-align-last: start !important;
}
</style>
